import React from 'react';
import { useMetamask } from "../../Scripts/UseMetamask";
import {
  SidebarContainer,
  Icon,
  CloseIcon,
  SidebarWrapper,
  SidebarMenu,
  SidebarLink,
  SideBarBtnConnected,
  SideBarBtnConnect,
  SideBtnWrap
} from './SidebarElements';

const Sidebar = ({ isOpen, toggle }) => {
  const {connect, account} = useMetamask();
  
  return (
    <SidebarContainer isOpen={isOpen} onClick={toggle}>
      <Icon onClick={toggle}>
        <CloseIcon />
      </Icon>
      <SidebarWrapper>
        <SidebarMenu>
          <SidebarLink
            target='_blank'
            href='https://twitter.com/spearheadirl'
            onClick={toggle}
            smooth={true}
            duration={500}
            spy={true}
            exact='true'
            offset={-80}
          >
            Twitter
          </SidebarLink>
          <SidebarLink
            target='_blank'
            href='https://discord.gg/tH7KR4Nn'
            onClick={toggle}
            smooth={true}
            duration={500}
            spy={true}
            exact='true'
            offset={-80}
          >
            Discord
          </SidebarLink>
          <SidebarLink
            target='_blank'
            href='https://nftkey.app/collections/gutterpunx/'
            onClick={toggle}
            smooth={true}
            duration={500}
            spy={true}
            exact='true'
            offset={-80}
          >
            NFTkey
          </SidebarLink>
        </SidebarMenu>
        <SideBtnWrap>
          {account ? (
            <SideBarBtnConnected>Connected</SideBarBtnConnected>
            ):(
            <SideBarBtnConnect onClick={ connect }>Connect</SideBarBtnConnect>
          )}
        </SideBtnWrap>
      </SidebarWrapper>
    </SidebarContainer>
  );
};

export default Sidebar;
